import script from "./demo-day-streaming-live-data.vue?vue&type=script&setup=true&lang=js"
export * from "./demo-day-streaming-live-data.vue?vue&type=script&setup=true&lang=js"

import "./demo-day-streaming-live-data.vue?vue&type=style&index=0&id=bb7b0c92&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb7b0c92"]])

export default __exports__